<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li v-for="(item,index) in partnerLogInfo.partners" :key="index" 
              @click="swatchPartner(item)"
              :class="{'selected':partnerLogInfo.conditions.ppId == item.ppId}">
              {{item.partnerName}}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{$t('partnerLog.queryCondition')}}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input 
                :placeholder="$t('partnerLog.inputUserName')"
                v-model="partnerLogInfo.conditions.personName"
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input 
                :placeholder="$t('partnerLog.selectLogAction')"
                v-model="partnerLogInfo.conditions.logAction"
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input 
                :placeholder="$t('partnerLog.selectStatus')"
                v-model="partnerLogInfo.conditions.state"
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="partnerLogInfo.conditions.queryStartTime"
                type="datetime"
                :placeholder="$t('partnerLog.selectStartTime')"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="partnerLogInfo.conditions.queryEndTime"
                type="datetime"
                :placeholder="$t('partnerLog.selectEndTime')"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button 
                type="primary" 
                @click="_queryPartnerLogMethod()"
                icon="el-icon-search">
                {{$t('partnerLog.query')}}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{$t('partnerLog.partnerLog')}}</span>
          </div>
          <el-table
            :data="partnerLogInfo.partnerLogs"
            style="width: 100%"
            border
            v-loading="loading">
            <el-table-column
              prop="logId"
              :label="$t('partnerLog.serialNumber')"
              align="center" />
            <el-table-column
              prop="logAction"
              :label="$t('partnerLog.logAction')"
              align="center" />
            <el-table-column
              prop="personId"
              :label="$t('partnerLog.userId')"
              align="center" />
            <el-table-column
              prop="personName"
              :label="$t('partnerLog.userName')"
              align="center" />
            <el-table-column
              prop="state"
              :label="$t('partnerLog.status')"
              align="center">
              <template #default="{row}">
                {{row.state=='10002'?$t('partnerLog.success'):$t('partnerLog.fail')}}
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('partnerLog.deliveryTime')"
              align="center" />
            <el-table-column
              :label="$t('partnerLog.operation')"
              align="center">
              <template #default="{row}">
                <el-button
                  size="mini"
                  @click="_openViewPartnerLogModel(row)">
                  {{$t('partnerLog.message')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="partnerLogInfo.conditions.page"
            :page-size="partnerLogInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="partnerLogInfo.total"
            style="margin-top: 20px; text-align: right;" />
        </el-card>
      </el-col>
    </el-row>

    <show-partner-log ref="showPartnerLog"></show-partner-log>
  </div>
</template>

<script>
import { listPartnerLog, listPartnerPool } from '@/api/partner/partnerLogApi'
import { getShopId } from '@/api/shop/shopApi'
import ShowPartnerLog from '@/components/partner/showPartnerLog'

export default {
  name: 'PartnerLog',
  components: {
    ShowPartnerLog
  },
  data() {
    return {
      loading: false,
      partnerLogInfo: {
        partnerLogs: [],
        partners: [],
        total: 0,
        conditions: {
          ppId: '',
          logAction: '',
          state: '',
          personName: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this.partnerLogInfo.conditions.shopId = getShopId()
    this._listPartners()
  },
  methods: {
    handleCurrentChange(val) {
      this.partnerLogInfo.conditions.page = val
      this._listPartnerLogs()
    },
    async _listPartnerLogs() {
      this.loading = true
      try {
        const res = await listPartnerLog(this.partnerLogInfo.conditions)
        this.partnerLogInfo.partnerLogs = res.data
        this.partnerLogInfo.total = res.total
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    _openViewPartnerLogModel(log) {
      this.$refs.showPartnerLog.open(log)
    },
    _queryPartnerLogMethod() {
      this.partnerLogInfo.conditions.page = 1
      this._listPartnerLogs()
    },
    async _listPartners() {
      try {
        const res = await listPartnerPool({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.partnerLogInfo.partners = res.data
        if (res.data && res.data.length > 0) {
          this.partnerLogInfo.conditions.ppId = res.data[0].ppId
          this._listPartnerLogs()
        }
      } catch (error) {
        console.error(error)
      }
    },
    swatchPartner(partner) {
      this.partnerLogInfo.conditions.ppId = partner.ppId
      this._listPartnerLogs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>